import React, { useEffect, useState } from "react"
import Link from "next/link"
import { useAuth } from "@dustin-web/microsite-components/src/auth"
import { useTranslations } from "@dustin-web/microsite-components/src/hooks"
import Icon, { IconName } from "@dustin-web/microsite-components/src/icon"
import { DigitalData } from "@dustin-web/microsite-components/src/utils/digital-data"

type Link = {
  text: string
  icon: IconName,
  href: string,
  trackingEvent: string
}

const LOGGED_OUT_LINKS: Link[] = [
  {
    text: 'Header_Login',
    icon: 'log-in',
    href: '/login',
    trackingEvent: 'login'
  },
  {
    text: 'Header_Register',
    icon: 'user-plus',
    href: '/registration',
    trackingEvent: 'register'
  }

] as const

const LOGGED_IN_LINKS: Link[] = [
  {
    text: 'OrderHistory',
    icon: 'doc',
    href: '/orders',
    trackingEvent: 'order_history'
  }
] as const

const SearchUserLinks = ({ searchPhrase }: { searchPhrase: string }) => {
  const [links, setLinks] = useState<Link[]>(LOGGED_OUT_LINKS)
  const { translate } = useTranslations()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      setLinks(LOGGED_IN_LINKS)
      return
    }

    setLinks(LOGGED_OUT_LINKS)
  }, [isAuthenticated])

  return (
    <ul className="c-header__autocomplete-mini-list">
      {links.map(({ href, icon, text, trackingEvent }, index) => (
        <li key={index} className="c-header__autocomplete-mini-item">
          <Link
            href={href}
            aria-label={translate(text)}
            onClick={() => DigitalData.pushSearchDropdownInteraction(trackingEvent, searchPhrase)}
            className="c-header__autocomplete-mini-link u-decoration-underline">
            <Icon className="c-header__autocomplete-mini-icon" name={icon} />
            <span className="c-header__autocomplete-mini-text">{translate(text)}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default SearchUserLinks
